import { Directive, Input, Host, Self, AfterViewInit } from '@angular/core';
import {MatAutocompleteTrigger, MatAutocomplete} from '@angular/material/autocomplete';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[terraForceAutoCompleteSelection]'
})
export class ForceAutoCompleteSelectionDirective extends OnDestroyMixin implements AfterViewInit {

  @Input()
  matAutocomplete: MatAutocomplete;

  constructor(
    @Host() @Self() private readonly autoCompleteTrigger: MatAutocompleteTrigger,
    private readonly ngControl: NgControl) {
      super();
  }

  ngAfterViewInit() {
    // When leaving the autocomplete panel
    this.autoCompleteTrigger.panelClosingActions.pipe(
      untilComponentDestroyed(this)
    ).subscribe((e) => {
      // If no option was selected
      if (!e || !e.source) {
        // Check if a valid value is already inputted
        const selected = this.matAutocomplete.options
            .map(option => option.value)
            .find(option => option === this.ngControl.value);

        if (selected == null) {
          this.ngControl.reset();
          this.ngControl.control.markAsTouched();
        }
      }
    });
  }
}
